
define('ldsh!modules/invoice_line/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>InvoiceLine</h1>\n<dl>\n  \n\t <dd>\n   <span name="invoice_id"></span>\n  </dd>\n  \n\t <dd>\n   <span name="name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="description"></span>\n  </dd>\n  \n\t <dd>\n   <span name="unit_cost"></span>\n  </dd>\n  \n\t <dd>\n   <span name="quantity"></span>\n  </dd>\n  \n\t <dd>\n   <span name="tax1_name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="tax2_name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="tax2_percent"></span>\n  </dd>\n  \n\t <dd>\n   <span name="tax1_percent"></span>\n  </dd>\n  \n\t <dd>\n   <span name="type"></span>\n  </dd>\n\n</dl>';

}
return __p
};});

